import axiosInstance from "api/utils/axiosInstance";
import { URLS } from "api/utils/baseUrls";

const sendChatbotAnswer = async (payload) => {
  try {
    const { data } = await axiosInstance.post(`${URLS.chatbot}/chat`, payload);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const chatbotApi = { sendChatbotAnswer };
